import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import ReactLinkify from "react-linkify"
import { Download, ChevronRight, PaperclipIcon } from "lucide-react"
import HTMLReactParser from "html-react-parser"

const BASE_HOST = "https://mpscnk.aestree.com/api/website"

export default function Notices () {
  const [notices, setNotices] = useState([])

  useEffect(() => {
      fetch(`${BASE_HOST}?notices`)
      .then(res => res.json())
      .then(data => setNotices(data.notices))
      .then(() => {
      })
  }, [])

  return (
    <>
      <div className="container">
        <h2 className="h3 py-2 pt-4 text-center">Notices</h2>

        <div>
          {notices && notices.length > 0 ? notices.map((notice, index) => (
            <NoticeItem key={index} notice={notice} />
          )) : <p style={{textAlign: "center"}}>No notices available at this time!</p>}
        </div>
      </div>
    </>
  )
}

export function NoticeItem (props) {
  const url = `${BASE_HOST}/notices`
  const [searchParams, setSearchParams] = useSearchParams();
  const noticeId = searchParams.get("id")
  const FILE_URL = `${url}/${props.notice.row_id}/file`
  const FILE_NAME = `notice_${props.notice.row_id}`;

  const [isExpanded, setIsExpanded] = useState(noticeId == props.notice.row_id)

  function handleNoticeClick () {
    setIsExpanded(prevState => !prevState)
  }

  const handleDownload = () => {
    const link = document.createElement("a")
    link.href = FILE_URL

    link.setAttribute("download", FILE_NAME)

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  };

  return (
    <div className="border border-gray-600 py-3 px-4 rounded mb-3 last:mb-0">
      <div className="flex items-center justify-between" style={{cursor: "pointer"}} onClick={props.notice.message ? handleNoticeClick : handleDownload}>
        <div>
          <p style={{backgroundColor: "#6b7280", color: "#fff", width: "fit-content", fontSize: "14px", padding: "2px 10px", borderRadius: "5px", marginBottom: "5px"}}>{props.notice.starts_at_date}</p>
          <p style={{fontWeight: 700}}>{props.notice.title}</p>
        </div>
        <p>{props.notice.file_attachment && !props.notice.message ? <Download className="h-5 w-5 text-gray-400 flex-shrink-0" /> : <ChevronRight style={{rotate: `${isExpanded ? '90deg' : ''}`, transition: "rotate .2s ease"}} />}</p>
      </div>
      {
        props.notice.message && isExpanded &&
        <p className="text-sm">
          <ReactLinkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
                <a target="blank" href={decoratedHref} key={key}>
                    {decoratedText}
                </a>
            )}
            >
            {HTMLReactParser(props.notice.message)}
          </ReactLinkify>
        </p>
      }
      {props.notice.file_attachment ? <button className="flex items-center gap-1 border border-muted-foreground rounded-lg px-2 py-1 w-fit text-sm mt-3 hover:bg-muted-foreground hover:text-white transition-colors" onClick={handleDownload}><PaperclipIcon size={18} /> Attachment</button> : ""}
    </div>
  )
}